import React from 'react';
import { useIntl } from 'react-intl';
import { Modal } from '@eventbrite/marmalade';
import styles from './AboutThisEventModal.module.scss';

export type AboutThisEventModalProps = {
  visible: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

export const AboutThisEventModal: React.FC<AboutThisEventModalProps> = React.memo(({ visible, onClose, children }) => {
  const { formatMessage } = useIntl();

  return (
    <Modal
      className={styles.modalContainer}
      isShown={visible}
      mobileVariant="drawer"
      headerTitle={formatMessage({ id: 'Overview' })}
      handleClose={onClose}
      closeTitle={formatMessage({ id: 'Close' })}
    >
      <div className={styles.modulesWrapper}>{children}</div>
    </Modal>
  );
});

AboutThisEventModal.displayName = 'AboutThisEventModal';
